<template>
  <div
    :class="`message-container ${theme.isDark ? 'message-container_dark' : null}`"
    v-if="emails.length !== 0"
  >
    <Email
      v-for="email in emails"
      :key="email.id"
      :author="`${email.fname} ${email.lname}`"
      :text="email.text"
      :created="email.createdAt"
    />
  </div>
  <div
    v-else
    :class="`message-container message-container_empty ${
      theme.isDark ? 'message-container_dark' : null
    }`"
  >
    <p>No emails</p>
  </div>
</template>

<script>
import Email from "./Email";

export default {
  name: "EmailsContainer",
  inject: ["theme"],
  props: {
    emails: Array,
  },
  components: {
    Email,
  },
};
</script>
